import produce from 'immer';
import {
  FREE_NFT_EVENT_CREATE_REQUEST, FREE_NFT_EVENT_INFO_DELETE_REQUEST,
  FREE_NFT_EVENT_INFO_DETAILS,
  FREE_NFT_EVENT_INFO_DETAILS_REQUEST,
  FREE_NFT_EVENT_INFO_UPDATE_REQUEST,
  FREE_NFT_EVENT_LIST,
  FREE_NFT_EVENT_LIST_REQUEST, FREE_NFT_EVENT_PAGE_RESET,
  FREE_NFT_EVENT_RESPONSE_MESSAGE, SET_FREE_NFT_EVENT_PAGINATION, SET_TOTAL_COUNT
} from '../../constants/event/freeNFTEventConstants';

const initialState = {
  list: [],
  resultCode: null,
  message: null,
  page: 1,
  pageLength: 10,
  totalCount: 0,
  searchString: '',
  searchType: '',
  scheduleInfo: [],
  logInfo: [],
};

const freeNFTEventReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case FREE_NFT_EVENT_LIST_REQUEST:
      break;
    case FREE_NFT_EVENT_LIST:
      draft.list = action.list;
      break;
    case FREE_NFT_EVENT_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case FREE_NFT_EVENT_CREATE_REQUEST:
      break;
    case FREE_NFT_EVENT_INFO_DETAILS_REQUEST:
      break;
    case FREE_NFT_EVENT_INFO_DETAILS:
      draft.scheduleInfo = action.scheduleInfo;
      draft.logInfo = action.logInfo;
      break;
    case FREE_NFT_EVENT_INFO_UPDATE_REQUEST:
      break;
    case FREE_NFT_EVENT_INFO_DELETE_REQUEST:
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_FREE_NFT_EVENT_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.searchType = action.searchType;
      draft.searchString = action.searchString;
      break;
    case FREE_NFT_EVENT_PAGE_RESET:
      draft.page = 1;
      break;
    default:
      break;
  }
});

export default freeNFTEventReducer;
